import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./search-modal.module.scss";
const SearchModal = ({ selectedScript, list, onSelect, flag, hideFinNifty, hideSensex, componentName, }) => {
    //   console.log("KK list ", selectedScript);
    //  console.log(flag,"flag", flag && flag.length);
    const indicesList = hideSensex
        ? ["NIFTY", "BANKNIFTY", "FINNIFTY", "MIDCPNIFTY"]
        : [
            "NIFTY",
            "BANKNIFTY",
            "FINNIFTY",
            // "SENSEX",
            "MIDCPNIFTY",
            // "BANKEX",
        ];
    return (_jsxs("div", Object.assign({ className: `${styles.searchModal} ${componentName === "PreDefine" ? styles.searchModalPreDefine : ""}` }, { children: [_jsx("div", { children: (flag === null || flag === void 0 ? void 0 : flag.length) === 0 && !hideFinNifty && (_jsxs(_Fragment, { children: [_jsx("h6", Object.assign({ className: `${styles.indicesText} regularWeight medium mb-1` }, { children: "Indices" })), indicesList === null || indicesList === void 0 ? void 0 : indicesList.map((item, index) => {
                            return (_jsx("div", Object.assign({ className: `${styles.searchItem} ${styles.indicesItem}`, onClick: () => {
                                    onSelect(item);
                                } }, { children: _jsx("span", Object.assign({ className: "medium mediumWeight" }, { children: item })) }), `${index}_${item}`));
                        })] })) }), _jsx("h6", Object.assign({ className: `${styles.indicesText} regularWeight medium my-1` }, { children: "FnO Stocks" })), list === null || list === void 0 ? void 0 : list.map((item, index) => {
                return (_jsx("div", Object.assign({ className: styles.searchItem, onClick: () => onSelect(item) }, { children: _jsx("span", Object.assign({ className: "medium mediumWeight" }, { children: item })) }), `${index}_${item}`));
            })] })));
};
export default SearchModal;
